<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_2">
<p class="calibre3"><span id="Page_0"></span></p>
<div class="figcenter2" id="i_frontis">
<img alt="A frolic would follow" class="w" id="id-2653064939457301408" src="Images/img0022.jpg"/>
<div class="caption"><p class="caption1"><span class="smcap1">A frolic would follow</span></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?134cba1a